<template>
  <div>
    <div class="black-overlay"></div>
    <div class="modal modal--resume_game" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1>{{ getTranslations.home_modals_resume_game_welcome_back }} {{ userDetails.username }}!</h1>
          <h2>{{ getTranslations.home_modals_resume_game_msg_to_continue_the_game }}</h2>
          <div class="avatars">
            <div class="avatar avatar--player1">
              <img :src="playersDetails.homePlayerAvatar" alt="">
              <span>{{ playersDetails.homePlayerUsername }}</span>
            </div>
            <div class="avatar avatar--player2">
              <img :src="playersDetails.awayPlayerAvatar" alt="">
              <span>{{ playersDetails.awayPlayerUsername }}</span>
            </div>
          </div>
        </div>
        <div class="modal__body">
          <a @click.prevent="resumeGame" style="cursor:pointer" class="btn2 btn2--std btn2--medium">{{ getTranslations.home_modals_resume_game_resume_game }}</a>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'resume-game',
  methods: {
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('game', [
      'setGameResuming',
      'setTransitionOnlyForSearchingToOpponent',
    ]),
    resumeGame() {
      this.setGameResuming(true);
      this.storeModalForHomePage(null);
      if (this.transitionOnlyForSearchingToOpponent) {
        this.setTransitionOnlyForSearchingToOpponent(false);
      }
      this.checkIfGameToResumeExists().then(() => {
        if (this.gameInProgress) {
          this.$router.replace('/resumingGame');
        } else {
          this.getUserLoginDetails().then(() => {
            this.closeResumeGameModal();
          });
        }
      });
    },
    closeResumeGameModal() {
      /* eslint-disable */
      $('.modal, .modal-overlay').fadeOut();
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('game', [
      'gameInProgress',
      'transitionOnlyForSearchingToOpponent',
      'playersDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ResumeGame.vue